import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'wouter';

import { PASSWORD_RESET } from '~/routes/paths';
import { Actions } from '~/store/login/actions';
import { getState as getLoginState } from '~/store/login/selectors';
import { getState as getPasswordState } from '~/store/password/selectors';

export const useLoginState = () => {
  const state = useSelector(getLoginState);
  return {
    success: state.success,
    url: state.samlRedirectUrl,
    error: state.error,
    loading: state.loading,
  };
};

export const useResetPasswordOnLogin = (): void => {
  const { resetToken } = useSelector(getPasswordState);
  const [, navigate] = useLocation();

  useEffect((): void => {
    if (resetToken) {
      // The token is already held in redux (SET_RESET_TOKEN); navigate without
      // putting it in the URL so it is never written to browser history. The
      // PasswordReset page reads it back from the store.
      navigate(PASSWORD_RESET);
    }
  }, [resetToken]);
};

export const useSSOLogin = (): ((
  username: string,
  runningOnBackground?: boolean,
) => void) => {
  const dispatch = useDispatch();

  return (username: string, runningOnBackground = false): void => {
    const redirectPath = window.location.toString();
    dispatch(
      Actions.USERNAME_LOGIN_REQUEST({
        username,
        redirectPath,
        runningOnBackground,
      }),
    );
  };
};

export const useUsernamePasswordLogin = (): ((
  username: string,
  password: string,
) => void) => {
  const dispatch = useDispatch();
  return (username: string, password: string): void => {
    dispatch(Actions.PASSWORD_LOGIN_REQUEST({ username, password }));
  };
};
